module.exports = __webpack_public_path__ + "static/work-2-420847e871240cc25d9fb6cd680ac273.jpg";